// src/components/planning/ServiceCard/utils/dateUtils.ts

import { LiturgicalClass } from '../../types/coreDomainTypes';

/**
 * Formats a date string into a long-form date (e.g., "Monday, January 1")
 */
export const formatDate = (dateString: string): string => {
    // Parse date components directly to avoid timezone issues
    // Backend sends dates as "YYYY-MM-DD" strings
    const dateOnly = dateString.split('T')[0]; // Handle both "2026-01-06" and "2026-01-06T..."
    const [year, month, day] = dateOnly.split('-').map(Number);

    // Create date using UTC to avoid timezone shifts
    const date = new Date(Date.UTC(year, month - 1, day));

    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC' // Use UTC to match the date exactly
    };

    const formatted = date.toLocaleDateString('en-US', options);

    return formatted;
  };
  
  /**
   * Normalizes liturgical season names to consistent class names for styling
   */
  export const getLiturgicalClass = (season: string | undefined): LiturgicalClass => {
    if (!season) return 'ordinary';
    
    const normalizedSeason = season.toLowerCase().replace(/\s+/g, '');
    
    switch (normalizedSeason) {
      case 'advent':
        return 'advent';
      case 'christmas':
      case 'christmastide':
        return 'christmas';
      case 'epiphany':
      case 'epiphanytide':
        return 'epiphany';
      case 'lent':
      case 'lenten':
        return 'lent';
      case 'holyweek':
        return 'holyweek';
      case 'easter':
      case 'eastertide':
        return 'easter';
      case 'pentecost':
      case 'pentecostday':
      case 'pentecost_day':
      case 'pentecost-day':
      case 'dayofpentecost':
        return 'pentecost';
      case 'ordinary':
      case 'ordinarytime':
      default:
        return 'ordinary';
    }
  };